function Mouse(){

    this.build();

}

Mouse.prototype.build = function(){

    if( hasTouch )
        return false;

    this.isStuck = false;
    this.isStuckBorderColor = "#DE8B21";
    this.isHoverState = false;
    this.target = null;
    this.initCursor();
    this.initHovers();

};

Mouse.prototype.initCursor = function() {
    const { Back } = window;

    this.outerCursor = document.querySelector(".circle-cursor--outer");
    this.innerCursor = document.querySelector(".circle-cursor--inner");

    this.outerCursorBox = this.outerCursor.getBoundingClientRect();
    this.outerCursorSpeed = 0;

    this.easing = Back.easeOut.config(1.7);
    this.clientX = -100;
    this.clientY = -100;
    this.showCursor = false;

    ///// ********* BTN ********* //////
    this.btn = document.querySelector(".btn");
    if( this.btn ) {
        this.btnBox = this.btn.getBoundingClientRect();
        this.distanceToTrigger = this.btnBox.width * 1.5;

        this.btnItems = document.querySelectorAll(".btn");
        this.btnItems.forEach(function (el, i) {
            el.renderedStyles = {
                tx: {previous: 0, current: 0, amt: 0.1},
                ty: {previous: 0, current: 0, amt: 0.1},
                scale: {previous: 1, current: 1, amt: 0.2}
            };
        });

        this.renderedStyles = {
            tx: {previous: 0, current: 0, amt: 0.1},
            ty: {previous: 0, current: 0, amt: 0.1},
            scale: {previous: 1, current: 1, amt: 0.2}
        };
    }
    ///// ********* END BTN ********* //////

    const unveilCursor = () => {
        gsap.set(this.innerCursor, {
            x: this.clientX,
            y: this.clientY
        });
        gsap.set(this.outerCursor, {
            x: this.clientX - this.outerCursorBox.width / 2,
            y: this.clientY - this.outerCursorBox.height / 2
        });
        setTimeout(() => {
            this.outerCursorSpeed = 0.2;
        }, 100);
        this.showCursor = true;
    };
    document.addEventListener("mousemove", unveilCursor);

    document.addEventListener("mousemove", e => {
        this.clientX = e.clientX;
        this.clientY = e.clientY;
    });

    const render = () => {
        gsap.set(this.innerCursor, {
            x: this.clientX,
            y: this.clientY
        });

        if( this.isHoverState ){

            gsap.to(this.outerCursor, this.outerCursorSpeed, {
                x: this.clientX - this.outerCursorUpadatedSize / 2,
                y: this.clientY - this.outerCursorUpadatedSize / 2,
                width: this.outerCursorUpadatedSize,
                height: this.outerCursorUpadatedSize,
                borderColor: "#6D6A64",
                opacity: 0.2
            });

        } else if( this.isStuck ){

            let btnHover = this.target.getBoundingClientRect();

            gsap.to(this.outerCursor, this.outerCursorSpeed, {
                x: btnHover.left,
                y: btnHover.top,
                width: btnHover.width,
                height: btnHover.height,
                borderColor: that.isStuckBorderColor,
                opacity: 1
            });

        } else {

            gsap.to(this.outerCursor, this.outerCursorSpeed, {
                x: this.clientX - this.outerCursorBox.width / 2,
                y: this.clientY - this.outerCursorBox.height / 2,
                width: 40,
                height: 40,
                borderColor: "#6D6A64",
                opacity: 0.2
            });

        }

        if (this.showCursor) {
            document.removeEventListener("mousemove", unveilCursor);
        }

        ///// ********* BTN ********* //////
        this.distanceToBtn();
        ///// ********* END BTN ********* //////

        requestAnimationFrame(render);
    };
    requestAnimationFrame(render);

    this.fullCursorSize = 70;
    this.enlargeCursorTween = gsap.to(this.outerCursor, 0.3, {
        width: this.fullCursorSize,
        height: this.fullCursorSize,
        ease: this.easing,
        paused: true
    });

    this.svgCircle = document.getElementById("plus");
    this.svgCircle2 = document.getElementById("plus2");

    let that = this;

    this.morphSVGtl = gsap.timeline({
        autoRemoveChildren: true
    }).pause();

};

Mouse.prototype.morphSvg = function(first, second, color = "#DE8B21"){

    this.morphSVGtl.to(this.svgCircle, {
        morphSVG : first,
        fill: color
    }, "label");
    this.morphSVGtl.to(this.svgCircle2, {
        morphSVG : second,
        fill: color
    }, "label");
    this.morphSVGtl.play();

};

Mouse.prototype.resetMorphSvg = function(first, second){

    this.morphSVGtl.to(this.svgCircle, {
        morphSVG : this.svgCircle,
        fill: "#DE8B21"
    }, "label");
    this.morphSVGtl.to(this.svgCircle2, {
        morphSVG : this.svgCircle2,
        fill: "#DE8B21"
    }, "label");
    this.morphSVGtl.play();

};

Mouse.prototype.killTweens = function(){
    gsap.killTweensOf( ".circle-cursor--outer" );
    gsap.killTweensOf( ".circle-cursor--inner" );
};

Mouse.prototype.handleMouseEnter = function(e){
    this.killTweens();
    this.isHoverState = true;
    this.outerCursorUpadatedSize = this.fullCursorSize;
    this.enlargeCursorTween.play();
    this.morphSvg('#arrow','#arrow');
};

Mouse.prototype.handleMouseLeave = function(){
    this.killTweens();
    this.isHoverState = false;
    this.isStuck = false;
    this.isStuckBorderColor = "#DE8B21";
    this.enlargeCursorTween.reverse();
    this.resetMorphSvg();
};

Mouse.prototype.btnMouseEnter = function(e){
    this.killTweens();
    this.isStuck = true;
    this.target = e.currentTarget;
};

Mouse.prototype.submitMouseEnter = function(e){
    this.killTweens();
    this.isStuck = true;
    this.target = e.currentTarget.querySelector(".svg-submit");
};

Mouse.prototype.viewMoreMouseEnter = function(e){
    this.killTweens();
    this.isHoverState = true;
    this.outerCursorUpadatedSize = this.fullCursorSize;
    this.enlargeCursorTween.play();
    this.morphSvg('#arrow','#arrow', "#1D2F3A");
};

Mouse.prototype.backLgPrev = function(e){
    this.killTweens();
    this.target = e.currentTarget;
    this.isStuck = true;
    this.outerCursorUpadatedSize = this.fullCursorSize;
    this.enlargeCursorTween.play();
    this.morphSvg('#prev','#prev');
};

Mouse.prototype.nextLgPrev = function(e){
    this.killTweens();
    this.target = e.currentTarget;
    this.isStuck = true;
    this.outerCursorUpadatedSize = this.fullCursorSize;
    this.enlargeCursorTween.play();
    this.morphSvg('#next','#next');
};

Mouse.prototype.closeLg = function(e){
    this.killTweens();
    this.target = e.currentTarget;
    this.isStuck = true;
    this.outerCursorUpadatedSize = this.fullCursorSize;
    this.enlargeCursorTween.play();
    this.morphSvg('#close','#close');
};

Mouse.prototype.backMouseEnter = function(e){
    this.killTweens();
    this.target = e.currentTarget.querySelector('.svg');
    this.isStuck = true;
};

Mouse.prototype.dragMouseEnter = function(){
    this.killTweens();
    this.isHoverState = true;
    this.outerCursorUpadatedSize = this.fullCursorSize;
    this.enlargeCursorTween.play();
    this.morphSvg('#drag1','#drag2');
};

Mouse.prototype.enlargeMouseEnter = function(e){
    this.killTweens();
    this.isStuck = true;
    this.isStuckBorderColor = "#ffffff";
    this.isHoverState = false;
    this.target = e.currentTarget;
    this.morphSvg('#enlarge1','#enlarge2', '#ffffff');
};

Mouse.prototype.distance = function(x1,y1,x2,y2){
    let a = x1 - x2;
    let b = y1 - y2;

    return Math.hypot(a,b);
};

// Linear interpolation
Mouse.prototype.lerp = function(a, b, n){
    return (1 - n) * a + n * b;
};

Mouse.prototype.distanceToBtn = function(){

    let that = this;

    if( !this.btnItems )
        return;

    this.btnItems.forEach(el => {

        el.x = 0;
        el.y = 0;

        el.btnBox = el.getBoundingClientRect();
        let text = el.querySelector('.btn-text');
        el.distanceToTrigger = el.btnBox.width*1.5;

        el.distanceMouseButton = that.distance(this.clientX, this.clientY, el.btnBox.left + el.btnBox.width/2, el.btnBox.top + el.btnBox.height/2);

        if ( el.distanceMouseButton < el.distanceToTrigger ) {
            el.x = (this.clientX - (el.btnBox.left + el.btnBox.width/2))*0.3;
            el.y = (this.clientY - (el.btnBox.top + el.btnBox.height/2))*0.3;
        }

        el.renderedStyles.tx.current = el.x;
        el.renderedStyles.ty.current = el.y;

        for (const key in el.renderedStyles ) {
            el.renderedStyles[key].previous = this.lerp(el.renderedStyles[key].previous, el.renderedStyles[key].current, el.renderedStyles[key].amt);
        }

        text.style.transform = `translate3d(${-el.renderedStyles.tx.previous*0.2}px, ${-el.renderedStyles.ty.previous*0.2}px, 0)`;
        el.style.transform = `translate3d(${el.renderedStyles.tx.previous}px, ${el.renderedStyles.ty.previous}px, 0)`;

    });

};

Mouse.prototype.initHovers = function() {

    let that = this;

    const gridItems = document.querySelectorAll("a:not(.btn):not(.no-hover-effect)");
    gridItems.forEach(el => {
        el.addEventListener("mouseenter", that.handleMouseEnter.bind(this));
        el.addEventListener("mouseleave", that.handleMouseLeave.bind(this));
    });

    const viewMoreItems = document.querySelectorAll(".hover-view-more");
    viewMoreItems.forEach(el => {
        el.addEventListener("mouseenter", that.viewMoreMouseEnter.bind(this));
        el.addEventListener("mouseleave", that.handleMouseLeave.bind(this));
    });

    const dragItems = document.querySelectorAll(".hover-drag");
    dragItems.forEach(el => {
        el.addEventListener("mouseenter", that.dragMouseEnter.bind(this));
        el.addEventListener("mouseleave", that.handleMouseLeave.bind(this));
    });

    const enlargeItems = document.querySelectorAll(".hover-enlarge");
    enlargeItems.forEach(el => {
        el.addEventListener("mouseenter", that.enlargeMouseEnter.bind(this));
        el.addEventListener("mouseleave", that.dragMouseEnter.bind(this));
    });

    if( this.btnItems ) {
        this.btnItems.forEach(el => {
            el.addEventListener("mouseenter", that.btnMouseEnter.bind(this));
            el.addEventListener("mouseleave", that.handleMouseLeave.bind(this));
        });
    }

    const iconLinkItems = document.querySelectorAll(".icon-link");
    iconLinkItems.forEach(el => {
        el.addEventListener("mouseenter", that.backMouseEnter.bind(this));
        el.addEventListener("mouseleave", that.handleMouseLeave.bind(this));
    });

    const submitItems = document.querySelectorAll(".form__submit");
    submitItems.forEach(el => {
        el.addEventListener("mouseenter", that.submitMouseEnter.bind(this));
        el.addEventListener("mouseleave", that.handleMouseLeave.bind(this));
    });

};
